import React, { useState, useEffect } from "react";
import "./NewPayment.css";
import { IoCloseCircleSharp } from "react-icons/io5";
import { TiTick } from "react-icons/ti";
import { Link, useNavigate } from "react-router-dom";
import { API } from "../../BackendConnections";
import { Button } from "react-bootstrap";
import { loadStripe } from "@stripe/stripe-js";
import { GrClose } from "react-icons/gr";

function NewPayment(props) {
  const [response, setResponse] = useState(null);
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };
  const fetchData = async () => {
    try {
      const response = await fetch(
        `${API}/api/payments/config/`
      ).then((result) => result.json());
      setResponse(response);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const user = {
      id: props?.id,
      userName: props?.userName,
    };
    try {
      const apiEndpoint = `${API}/api/payments/paymentRequest/${
        props && props.id
      }/`;
      const response1 = await fetch(apiEndpoint, user).then((result) =>
        result.json()
      );

      const stripe = await loadStripe(response.publicKey);
      const redirectResult = await stripe.redirectToCheckout({
        sessionId: response1.sessionId,
      });
      // console.log(redirectResult);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div className="price-plan-wrapper m-4">
      <div className="text-center d-flex justify-content-center">
        <img
          src="/assets/images/icons/analytics.svg"
          alt="icon"
          style={{ height: "70px", width: "auto" }}
        />
        &nbsp;&nbsp;
        <span
          className="text-center"
          style={{ marginTop: "15px", marginBottom: "10px", fontSize: "28px" }}
        >
          <label>
            <img
              src="\assets\images\goneetpay.png"
              alt="goneet"
              style={{ height: "50px", width: "auto" }}
            />
          </label>
        </span>
      </div>
      <span>
        <GrClose
          onClick={goBack}
          style={{ position: "absolute", top: "20", right: "20" }}
        />
      </span>
      <div className="text-center mt-4 mb-4">
        <p style={{ fontSize: "14px" }}>
          Join goneet PRO to access your Ranking, PEER Group Status <br />
          and PRO Profile enhancing Job Opportunities
        </p>
      </div>
      <div className="row">
        <div className="col-lg-6  col-md-10 ">
          <div
            className=" text-center p-3"
            style={{
              background: "white",
              border: "1px solid #adaeb2",
              borderRadius: "5px",
            }}
          >
            <div className="sub-head">
              <label style={{ color: "#253A76" }}>
                YOUR <b>Industry Ranking</b>{" "}
              </label>
              <div className="line mt-3" style={{ background: "red" }}></div>
              <div className="mt-3">
                <small className="mb-2">
                  Your Discipline Ranking within your PEER Group & enhanced
                  Profile including your Ranking & Key Competencies.
                </small>{" "}
                <br />
                <small>
                  Improve your Ranking and increase your employability.
                </small>
              </div>
            </div>
            <div className="mt-4">
              <img
                src="\assets\images\pdfScreenShot.png"
                alt=""
                style={{ height: "400px", width: "auto" }}
              />
            </div>
          </div>
        </div>

        <div className="col-lg-6  col-md-10 ">
          <div
            className="text-center p-3 "
            style={{
              background: "white",
              border: "1px solid #adaeb2",
              borderRadius: "5px",
            }}
          >
            <div className="sub-head">
              <label style={{ color: "#253A76" }}>
                YOUR <b>PRO Dashboard</b>
              </label>
              <div className="line mt-3" style={{ background: "red" }}></div>
              <div className="mt-3">
                <small className="mb-2 ">
                  Access your PRO Dashboard, see your Discipline Ranking and Key
                  Criteria.
                </small>{" "}
                <br /> <br />
                <small>
                  Target Improvement & Build your employability Status and
                  Industry Position.
                </small>
              </div>
            </div>
            <div className="mt-4">
              <img
                src="\assets\images\proPageScreenShot.PNG"
                alt=""
                style={{ height: "400px", width: "auto" }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="join-btn text-center mt-4">
        <form>
          <button type="submit" onClick={handleSubmit}>
            JOIN
          </button>
        </form>
      </div>
    </div>
  );
}

export default NewPayment;
